import axios from 'axios'
import router from '../router'

export default {
  requestWith (req) {
    let config = {}
    if (!req.hasOwnProperty('url') || !req.hasOwnProperty('method')) {
      req.resultCallback(null)
    }
    config.url = req.url
    config.method = req.method
    config.resultCallback = req.resultCallback
    if (req.hasOwnProperty('data')) {
      config.data = req.data
    }
    if (req.hasOwnProperty('params')) {
      config.params = req.params
    }
    // 토큰 필요성 체크
    this.fnCallApi(config)
  },
  fnCallApi (config) {
    axios(config.url, config)
      .then(response => {
        config.resultCallback(response)
      })
      .catch(error => {
        console.error(error)
        console.error(error.response)
        console.error(error.response.data)
        if (error.response.data !== undefined) {
          switch (error.response.data.status) {
            case 401:
              console.error('401에러: 토큰 재발급 요청', error)
              break
            case 450:
              console.error('450에러: 로그아웃 후 로그인 페이지로 이동', error)
              break
            default:
              console.error(error)
              break
          }
        } else {
          console.error('알 수 없는 에러', error)
        }
        this.moveLogin()
      })
  },
  moveLogin () {
    sessionStorage.clear()
    router.replace('/Login')
  }
}



// WEBPACK FOOTER //
// ./src/script/axiosDJ.js